module.exports = __webpack_public_path__ + "static/media/file-check-02.adadb24e.svg";